var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9178 16.2294L19.4179 0.229491C19.3256 0.0886226 19.1683 0.00390625 18.9999 0.00390625H10.9999C10.8317 0.00390625 10.6745 0.0886226 10.582 0.229491L0.0820366 16.2294C-0.0187929 16.383 -0.0273378 16.5797 0.0600641 16.7414C0.147222 16.9032 0.31641 17.0038 0.500003 17.0038H29.4998C29.6837 17.0038 29.8526 16.9032 29.94 16.7414C30.0274 16.5797 30.0189 16.383 29.9178 16.2294ZM11.27 1.0039H11.7536L3.90013 16.0038H1.42651L11.27 1.0039ZM15.4999 16.0038V14.0038H14.4999V16.0038H5.03098L12.881 1.0039H14.4999V1.5039H15.4999V1.0039H17.1176L24.9674 16.0038H15.4999ZM26.0999 16.0038L18.2499 1.0039H18.7335L28.5733 16.0038H26.0999Z",
    fill: "#255097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.00391H15.5V3.0039H14.5V2.00391Z",
    fill: "#255097"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.00391H15.5V5.5039H14.5V4.00391Z",
    fill: "#255097"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.50391H15.5V8.50389H14.5V6.50391Z",
    fill: "#255097"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.0039H15.5V12.5039H14.5V10.0039Z",
    fill: "#255097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/Road.5c090d076170fd5fee9ce8ca0bd20248.svg";
export { ForwardRef as ReactComponent };